import React from 'react';
import { InputNumber } from 'antd';
import { numberFormatter, numberParser } from '../../utils/numberUtils';

/**
 * ورودی مبلغ/قیمت — جداکننده هر سه رقم در تایپ و نمایش
 */
const WorkPriceInput = ({ className, style, min = 0, ...rest }) => (
  <InputNumber
    min={min}
    className={className ?? 'w-full'}
    style={{ width: '100%', fontFamily: 'CustomFont', ...style }}
    formatter={numberFormatter}
    parser={numberParser}
    {...rest}
  />
);

export default WorkPriceInput;
